import React from "react";
import { IconArrowLeft } from "@ui/icons";
import ZenDeskBtn from "@ui/zend-desk";

const BtnBack = ({ data }) => {
    if (!data) return null;
    const { text, url } = data;
    return (
        <a href={url} className="flex text-skin-primary">
            <IconArrowLeft className="w-5 h-5" /> {text}
        </a>
    );
};

const TopNavBar = ({ data }) => {
    return (
        <div className="flex justify-between items-center">
            <div>{data.backLink && <BtnBack data={data.backLink} />}</div>
            {(data.helpText || data.helpFullText) && (
                <div>
                    <ZenDeskBtn
                        {...data.helpTrackingData}
                        className="border-skin-primary border rounded-full px-4 py-1 text-skin-primary font-semibold inline-block"
                    >
                        <span className="md:hidden">{data.helpText}</span>
                        <span className="hidden md:inline">
                            {data.helpFullText ?? data.helpText}
                        </span>
                    </ZenDeskBtn>
                </div>
            )}
        </div>
    );
};

export default TopNavBar;
